import { ResponseGetPogAnalysis_OutputStorePogId_ } from "@CommonApi/pog-analysis/_outputStorePogId_";
import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { pogSummaryModalDataAtom } from "./atoms";

export const usePogSummaryModal = () => {
  const { openModal } = useModals();
  const setPogSummaryModalData = useSetAtom(pogSummaryModalDataAtom);

  const openPogSummaryModal = (data: ResponseGetPogAnalysis_OutputStorePogId_) => {
    setPogSummaryModalData(data);
    openModal("PogSummaryModal");
  };

  return { openPogSummaryModal };
};
